/**
 * 该文件存放一些平台相关的一些页面路由
 */

const platformAboutRoutes = [
  // 使用帮助
  {
    path: '/instruction/:companyType',
    name: 'Instruction',
    meta: {
      ignoreToken: true,
    },
    component: () => import('@/pages/login/instructions')
  },
  // 平台经营资质
  {
    path: '/bus-qualifications',
    name: 'BusQualifications',
    meta: {
      ignoreToken: true,
    },
    component: () => import('@/pages/bus-qualifications/bus-qualifications')
  },
  // 隐私政策
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    meta: {
      ignoreToken: true,
    },
    component: () => import('@/pages/bus-qualifications/privacy-policy')
  },
  // 平台介绍
  {
    path: '/platform-introduction',
    name: 'PlatformIntroduction',
    meta: {
      ignoreToken: true,
    },
    component: () => import('@/pages/bus-qualifications/platform-introduction')
  },
  // 电子认证服务协议
  {
    path: '/electronic-auth-service',
    name: 'EAuthService',
    meta: {
      ignoreToken: true,
    },
    component: () => import('@/pages/bus-qualifications/electronic-auth')
  },
  // 首营用户使用协议页面
  {
    path: '/user-agreement',
    name: 'UserAgreement',
    meta: {
      ignoreToken: true,
    },
    component: () => import('@/pages/bus-qualifications/user-agreement')
  },
];

export default platformAboutRoutes;
